import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { Signal, SignalThreadAccessEvent, SignalType } from "@types";
import { getSignalsListHeaderLabel, groupBy } from "@utils";
import { RootState } from "../store";

export const signalsListSelector = createDraftSafeSelector(
  (state: RootState) => state.signals.results,
  (signals) => {
    const groupedSignals = groupBy(signals, (signal) =>
      getSignalsListHeaderLabel(signal.eventDate)
    );

    const groupedSignalsArray = Object.entries(groupedSignals);
    const headerItemIndices = groupedSignalsArray.reduce<number[]>((acc, [_, signals], index) => {
      const prevIndex = acc[index - 1];

      if (typeof prevIndex === "undefined") {
        return [...acc, signals.length + 1];
      }

      return [...acc, prevIndex + signals.length + 1];
    }, []);

    return {
      list: groupedSignalsArray.reduce<(Signal | string)[]>(
        (acc, [label, signals]) => [...acc, label, ...signals],
        []
      ),
      headerItemIndices: [0, ...headerItemIndices.slice(0, -1)],
    };
  }
);

export const accessEventsListSelector = createDraftSafeSelector(
  (state: RootState) => state.signals.selectedSignal,
  (selectedSignal) => {
    if (!selectedSignal || selectedSignal.eventName !== SignalType.EmailOpened) {
      return {
        list: [],
        headerItemIndices: [],
      };
    }

    const groupedAccessEvents = groupBy(
      selectedSignal.eventMetadata.accessEvents.results,
      ({ accessDate }) => getSignalsListHeaderLabel(accessDate)
    );

    const groupedAccessEventsArray = Object.entries(groupedAccessEvents);

    const headerItemIndices = groupedAccessEventsArray.reduce<number[]>(
      (acc, [_, accessEvents], index) => {
        const prevIndex = acc[index - 1];

        if (typeof prevIndex === "undefined") {
          return [...acc, accessEvents.length + 1];
        }

        return [...acc, prevIndex + accessEvents.length + 1];
      },
      []
    );

    return {
      list: groupedAccessEventsArray.reduce<(SignalThreadAccessEvent | string)[]>(
        (acc, [label, events]) => [...acc, label, ...events],
        []
      ),
      headerItemIndices: [0, ...headerItemIndices.slice(0, -1)],
    };
  }
);
